export { TTDocumentLoadingError };
const TTDocumentLoadingError = (/*long:boolean*/) => {
  return (
    <p>
      An exception occurred loading this Document. Please refresh and try again,
      then contact support if the issue persists.
    </p>
  );
};
